<template>
  <div class="home">
    <v-container>
      <v-row>
        <v-col cols="6">
          Welcome to the dashboard
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Dashboard',
});
</script>
